/* eslint-disable @typescript-eslint/no-explicit-any -- aligné U3149WorkNatureListToolBar */
/* eslint-disable react-hooks/exhaustive-deps -- useMemo sur getSelectedRows() comme U3144 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';

import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000GridStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000GridStateHandlers';
import type { U2000TableHandlers } from '../../../u2000Core/types/U2000TableHandlers';
import { NS, U3150ROLES } from '../../U3150';

interface U3150TaskListToolBarProps<T extends Record<string, any>> {
  gridStateHandlers: U2000GridStateHandlers<T>;
  handlerActions?: U2000TableHandlers<T>;
}

export const U3150TaskListToolBar: React.FC<U3150TaskListToolBarProps<Record<string, any>>> = ({
  gridStateHandlers,
  handlerActions,
}) => {
  const { t } = useTranslation();
  const { hasRole } = useU2000AuthContext();

  const disableUpdateBtn = React.useMemo(() => {
    const selectedRows = gridStateHandlers.getSelectedRows();
    return selectedRows.length !== 1;
  }, [gridStateHandlers.getSelectedRows()]);

  const disableDeleteBtn = React.useMemo(() => {
    const selectedRows = gridStateHandlers.getSelectedRows();
    return selectedRows.length === 0;
  }, [gridStateHandlers.getSelectedRows()]);

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3150ROLES.ADD),
      handleClick: handlerActions?.onAdd,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3150ROLES.EDIT),
      handleClick: handlerActions?.onModify,
      disabled: disableUpdateBtn,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3150ROLES.DELETE),
      handleClick: handlerActions?.onDelete,
      disabled: disableDeleteBtn,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
